<i
  class="fa-star"
  [ngClass]="{ far: !isStarred, 'fas text-favorite': isStarred }"
  i18n-matTooltip
  matTooltip="Star this task"
></i>
